
export function availableThemes (siteSettings, type) {
  const themes = siteSettings?.available_themes || []

  return themes.filter(theme => {
    const available = (theme.element_types || []).indexOf(type) !== -1
    return theme.type === 'generic' && available;
  })
}

// Wrap plain text in bullet list HTML for Tech Advisor Plus so subheadlines show bullets by default from UI
function wrapPlainTextAsBulletList(value) {
  if (value == null || typeof value !== 'string') return value
  const trimmed = value.trim()
  if (!trimmed) return value
  if (trimmed.includes('<')) return value // already HTML
  return `<ul><li>${trimmed}</li></ul>`
}

export function themeDefaults(theme, type, subtype) {
  if (!theme?.defaults) return {}
  
  if (theme.defaults && theme.defaults[type]) {
    const ignoredKeys = subtype !== 'retirement' ? [] : [
      'headline',
      'link_text',
      'conversion_cta_text',
      'question',
      'answer1',
      'answer2'
    ];

    const themeStyleDefaults = theme.defaults[type] || {};

    const defaults = Object.keys(themeStyleDefaults).reduce((update, key) => {
      const value = themeStyleDefaults[key]

      if (!ignoredKeys.includes(key)) {
        update[key] = value
      }

      return update
    }, {});

    // Tech Advisor Plus: default caption/content as bullet list from UI (no hardcoded bullets in metadata)
    if (theme.id === 'tech-advisor-plus') {
      if (defaults.caption != null) defaults.caption = wrapPlainTextAsBulletList(defaults.caption)
      if (defaults.content != null) defaults.content = wrapPlainTextAsBulletList(defaults.content)
    }

    return { ...defaults, theme_id: theme.id, theme: theme }
  }
}

export function findTheme({ type, theme_id }, siteSettings) {
  const themes = availableThemes(siteSettings, type)
  return themes.find(({ id }) => theme_id === id)
}
